// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"3e5bbb13","239":"01513612","294":"958ff472","396":"efd1c931","453":"87bc933c","455":"5ef85a16","977":"bdfd3ad9"}[chunkId] + ".chunk.js";
};